import { Component, OnChanges, computed, input, inject } from '@angular/core';
import { I18nModule, I18nService } from '@pflegix/i18n';
import { GlobalSearchModel, IGlobalSearchModelResult } from '@pflegix/types';
import { DividerModule } from 'primeng/divider';
import { GLOBAL_SEARCH_NAMESPACE } from '../../i18n/config/global-search-translations.config';
import { globalSearchTranslationsDE } from '../../i18n/de/global-search.translations.de';
import { globalSearchTranslationsEN } from '../../i18n/en/global-search.translations.en';
import { GlobalSearchResultItemComponent } from '../global-search-result-item/global-search-result-item.component';

@Component({
  selector: 'pfx-global-search-result-wrapper',
  imports: [DividerModule, GlobalSearchResultItemComponent, I18nModule],
  templateUrl: './global-search-result-wrapper.component.html',
  styleUrl: './global-search-result-wrapper.component.scss',
})
export class GlobalSearchResultWrapperComponent implements OnChanges {
  private readonly i18nService = inject(I18nService);

  public globalSearchResult = input.required<IGlobalSearchModelResult[]>();

  public isLoading = input<boolean>(false);

  public selectedIndex = input<number>(-1);

  protected readonly GLOBAL_SEARCH_NAMESPACE = GLOBAL_SEARCH_NAMESPACE;

  protected hasResultData = false;

  protected GLOBAL_SEARCH_MODEL_TO_TITLE_MAPPING: Record<GlobalSearchModel, string> = {
    BusinessPartner: this.i18nService.t('businessPartner'),
    User: this.i18nService.t('user'),
    Lead: this.i18nService.t('leads'),
    Task: this.i18nService.t('tasks'),
    Post: this.i18nService.t('posts'),
    Application: this.i18nService.t('applications'),
    Order: this.i18nService.t('orders'),
    Documentation: this.i18nService.t('documentations'),
  };

  protected getFlatResults = computed(() => this.globalSearchResult().flatMap((result) => result.data));

  constructor() {
    this.loadTranslations();
  }

  public ngOnChanges(): void {
    this.hasResultData = this.checkResultHasData(this.globalSearchResult());
  }

  public get shouldShowSectionTitles(): boolean {
    return this.globalSearchResult().length > 1;
  }

  private loadTranslations(): void {
    this.i18nService.addTranslations({
      namespace: GLOBAL_SEARCH_NAMESPACE,
      de: globalSearchTranslationsDE,
      en: globalSearchTranslationsEN,
    });
  }

  private checkResultHasData(result: IGlobalSearchModelResult[]): boolean {
    return result.some((modelResult) => !!modelResult.data.length);
  }
}
